<template>
  <div class="app-filter-item">
    <div class="app-filter-item__inner" v-if="data.search">
      <div class="app-filter-item__label" v-if="data.label">{{ data.label }}</div>
      <div  class="app-filter-item__input-wrap">
        <input class="app-filter-item__input" :placeholder="data.search.placeholder"
               v-model="value"
               @input="$emit('change', data.name, value)"
               @change="$emit('change', data.name, value)"/>
        <button class="app-filter-item__input-button"></button>
      </div>
    </div>
    <div class="app-filter-item__inner" v-if="data.select">
      <div class="app-filter-item__label" v-if="data.label">{{ data.label }}</div>
      <multiselect v-model="value" :options="options"
                   :searchable="false"
                   :show-labels="false"
                   @select="selectValue(data.name, value)"
                   :placeholder="data.select.placeholder"/>
    </div>
    <div class="app-filter-item__inner"
         v-if="favorites">
      <div class="app-filter-item__label"
           :class="favorites ? 'link': ''"
           v-if="data.label"
           @click="toggleState">{{ label }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AppCardFilter',
  components: {},

  props: ['data'],
  data() {
    return {
      label: this.data.label,
      value: this.data.value || null,
    };
  },
  computed: {
    options() {
      let opts;
      if (this.data.select) {
        opts = Object.values(this.data.select.options);
        const empty = this.data.select.placeholder;
        opts = [empty].concat(opts);
      }
      return opts;
    },
    favorites() {
      if (this.data.favorites) {
        return true;
      }
      return this.data.favorites === false;
    },
  },
  methods: {
    selectValue(name, value) {
      const asArray = Object.entries(this.data.select.options);
      const filtered = asArray.filter(([, val]) => val === value);
      if (filtered.length > 0) {
        this.$emit('change', name, filtered[0][1], filtered[0][0]);
      } else {
        this.$emit('change', name, undefined);
      }
    },
    toggleState() {
      if (this.label === this.data.label) {
        this.label = this.data.toggleLabel;
        this.$emit('favorites-active');
      } else {
        this.label = this.data.label;
        this.$emit('favorites-inactive');
      }
    },
  },
};
</script>

<style lang="scss">
  @import "app-filter-item";
</style>
